import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterParty'
})
export class FilterPartyTPAPipe implements PipeTransform {

  transform(items: any[], searchText: string) {
    return items ? items.filter(item => item.partyName.search(new RegExp(searchText, 'i')) > -1) : [];
    }

}
